<template>
  <div class="flex w-full flex-col space-y-2 p-6">
    <div class="flex items-center space-x-2">
      <span class="text-xs font-bold text-ontick-carbon-900 dark:text-gray-300">
        Utilizar dados do usuário
      </span>
      <ontick-switch-component
        :active="useUserData"
        @switch="useUserData = $event"
      />
    </div>

    <div class="flex flex-col space-y-6 md:flex-row md:space-y-0 md:space-x-6">
      <payer-data-input-component
        class="h-full xl:w-2/3"
        :useUserData="useUserData"
      />
      <payment-info-component
        :useUserData="useUserData"
        :product="product"
        :planChangeType="planChangeType"
      />
    </div>
  </div>
</template>

<script>
import OntickSwitchComponent from "../../../shared/components/basic/ontick-switch.component.vue";
import payerDataInputComponent from "../components/payer-data-input.component.vue";
import PaymentInfoComponent from "../components/payment-info.component.vue";

export default {
  props: {
    product: {
      type: Object,
    },
    planChangeType: {
      type: String,
    },
  },

  components: {
    payerDataInputComponent,
    PaymentInfoComponent,
    OntickSwitchComponent,
  },

  data() {
    return {
      useUserData: true,
    };
  },
};
</script>

<style></style>
